module.exports = __webpack_public_path__ + "static/media/rotate_phone.fb50afb0.gif";